export default __webpack_public_path__ + "static/media/operationIcon.a0b5b87b.svg";